(() => {
  const bron = document.getElementById('vt-tijd');
  if (!bron) return;
  let c;
  try {
    c = JSON.parse(bron.textContent);
  } catch {
    return;
  }

  const minuten = (t, standaard) => {
    const [u, m] = String(t || '').trim().replace('.', ':').split(':');
    const uur = parseInt(u, 10);
    return Number.isNaN(uur) ? standaard : uur * 60 + (parseInt(m, 10) || 0);
  };
  const VAN = minuten(c.van, 9 * 60);
  const TOT = minuten(c.tot, 17 * 60 + 30);
  const AFKAP = minuten(c.afkap, 17 * 60);
  const AFHAAL_AFKAP = minuten(c.afhaal_afkap, 12 * 60);
  const GESLOTEN = new Set((c.gesloten || []).map((d) => d.trim()).filter(Boolean));
  const ZATERDAG = c.zaterdag === true;

  const klok = new Intl.DateTimeFormat('en-GB', {
    timeZone: c.tz || 'Europe/Amsterdam',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  });

  function nu() {
    const p = {};
    klok.formatToParts(new Date()).forEach((x) => { p[x.type] = x.value; });
    return { datum: `${p.year}-${p.month}-${p.day}`, min: Number(p.hour) * 60 + Number(p.minute) };
  }

  const alsDatum = (d) => new Date(`${d}T12:00:00Z`);
  const dagErna = (d) => {
    const x = alsDatum(d);
    x.setUTCDate(x.getUTCDate() + 1);
    return x.toISOString().slice(0, 10);
  };
  const isWerkdag = (d) => {
    const w = alsDatum(d).getUTCDay();
    return w >= 1 && w <= 5 && !GESLOTEN.has(d);
  };

  function isOpen(n = nu()) {
    return isWerkdag(n.datum) && n.min >= VAN && n.min < TOT;
  }

  const isBezorgdag = (d) =>
    isWerkdag(d) || (ZATERDAG && alsDatum(d).getUTCDay() === 6 && !GESLOTEN.has(d));

  function eersteNa(d, telt) {
    let x = dagErna(d);
    for (let i = 0; i < 31 && !telt(x); i += 1) x = dagErna(x);
    return x;
  }

  function levering(n = nu()) {
    const voor = isWerkdag(n.datum) && n.min < AFKAP;
    const verzenddag = voor ? n.datum : eersteNa(n.datum, isWerkdag);
    const bezorgdag = eersteNa(verzenddag, isBezorgdag);
    if (!voor) return { soort: 'dag', datum: bezorgdag };
    return bezorgdag === dagErna(n.datum) ? { soort: 'morgen' } : { soort: 'voor_dag', datum: bezorgdag };
  }

  function isStil(n = nu()) {
    if (!isWerkdag(n.datum)) return true;
    return n.min >= AFKAP && !isWerkdag(dagErna(n.datum));
  }

  function afhalen(n = nu()) {
    if (isWerkdag(n.datum) && n.min < AFHAAL_AFKAP) return { soort: 'vandaag' };
    const d = eersteNa(n.datum, isWerkdag);
    return d === dagErna(n.datum) ? { soort: 'morgen' } : { soort: 'dag', datum: d };
  }

  function bereikbaar(n = nu()) {
    if (isOpen(n)) return { soort: 'open' };
    if (isWerkdag(n.datum) && n.min < VAN) return { soort: 'vandaag' };
    const morgen = dagErna(n.datum);
    let d = morgen;
    for (let i = 0; i < 31 && !isWerkdag(d); i += 1) d = dagErna(d);
    return d === morgen ? { soort: 'morgen' } : { soort: 'dag', datum: d };
  }

  const dagnaam = (d) =>
    new Intl.DateTimeFormat(document.documentElement.lang || 'nl', {
      weekday: 'long', timeZone: 'UTC',
    }).format(alsDatum(d));

  function bijwerken() {
    const n = nu();
    const open = isOpen(n);
    document.querySelectorAll('[data-vt-open]').forEach((el) => {
      el.classList.toggle('is-dicht', !open);
      el.querySelectorAll('[data-vt-als]').forEach((kind) => {
        kind.hidden = (kind.dataset.vtAls === 'open') !== open;
      });
    });

    document.dispatchEvent(new CustomEvent('vt:tijd', { detail: { open } }));

    leveringBijwerken(document.querySelectorAll('[data-vt-levering]'), n);
    bereikBijwerken(n);
    aftelBijwerken(n);
    regelBijwerken(n);
    afhalenBijwerken(n);
  }

  function afhalenBijwerken(n) {
    const a = afhalen(n);
    const tekst = ((c.tekst && c.tekst[`afhalen_${a.soort}`]) || '')
      .replace('[dag]', a.datum ? dagnaam(a.datum) : '');
    if (!tekst) return;
    document.querySelectorAll('[data-vt-afhalen]').forEach((el) => {
      if (el.textContent !== tekst) el.textContent = tekst;
    });
  }

  function bereikBijwerken(n) {
    const b = bereikbaar(n);
    const tekst = ((c.tekst && c.tekst[`bereik_${b.soort}`]) || '')
      .replace('[dag]', b.datum ? dagnaam(b.datum) : '');
    if (!tekst) return;
    document.querySelectorAll('[data-vt-bereik]').forEach((el) => {
      if (el.textContent !== tekst) el.textContent = tekst;
    });
  }

  function aftelBijwerken(n) {
    const vandaag = isWerkdag(n.datum) && n.min < AFKAP;
    document.querySelectorAll('[data-vt-aftel]').forEach((el) => {
      if (!vandaag) { el.hidden = true; return; }
      const rest = AFKAP - n.min;
      const u = Math.floor(rest / 60);
      const tekst = ((u ? c.tekst.aftel_uur : c.tekst.aftel_min) || '')
        .replace('[u]', u).replace('[m]', rest % 60);
      if (el.textContent !== tekst) el.textContent = tekst;
      el.hidden = !tekst;
    });
  }

  function regelBijwerken(n) {
    let nu = 'dicht';
    if (isWerkdag(n.datum)) nu = n.min < AFKAP ? 'voor' : 'na';
    document.querySelectorAll('[data-vt-regel]').forEach((el) => {
      const ja = el.dataset.vtRegel === nu;
      el.classList.toggle('is-nu', ja);
      el.querySelectorAll('[data-vt-geldt]').forEach((l) => { l.hidden = !ja; });
    });
  }

  function leveringBijwerken(leveringen, n = nu()) {
    if (!leveringen.length) return;
    const v = levering(n);
    const stil = isStil(n);
    leveringen.forEach((el) => {
      const houder = el.closest('[data-vt-levering-stil]');
      if (houder) houder.classList.toggle('is-stil', stil);
      const soort = el.dataset.vtLevering === 'kort'
        ? (v.soort === 'morgen' ? 'kort_morgen' : 'kort_dag')
        : `levering_${v.soort}`;
      const tekst = (c.tekst && c.tekst[soort]) || '';
      if (!tekst) return;
      const nieuw = v.datum ? tekst.replace('[dag]', dagnaam(v.datum)) : tekst;
      if (el.textContent !== nieuw) el.textContent = nieuw;
    });
  }

  window.vtTijd = { isOpen: () => isOpen(), bijwerken };

  bijwerken();
  let tik = setInterval(bijwerken, 60 * 1000);
  document.addEventListener('visibilitychange', () => {
    clearInterval(tik);
    if (document.hidden) return;
    bijwerken();
    tik = setInterval(bijwerken, 60 * 1000);
  });

  const secties = new Set();
  document.querySelectorAll('[data-vt-levering]').forEach((el) => {
    secties.add(el.closest('.shopify-section') || el.parentElement);
  });
  if (window.MutationObserver && secties.size) {
    const waarnemer = new MutationObserver((rijen) => {
      const nieuw = [];
      let afhaal = false;
      rijen.forEach((r) => r.addedNodes.forEach((knoop) => {
        if (knoop.nodeType !== 1) return;
        if (knoop.matches('[data-vt-levering]')) nieuw.push(knoop);
        knoop.querySelectorAll('[data-vt-levering]').forEach((el) => nieuw.push(el));
        if (knoop.matches('[data-vt-afhalen]') || knoop.querySelector('[data-vt-afhalen]')) afhaal = true;
      }));
      if (nieuw.length) leveringBijwerken(nieuw);
      if (afhaal) afhalenBijwerken(nu());
    });
    secties.forEach((s) => waarnemer.observe(s, { childList: true, subtree: true }));
  }
})();
